var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 80.705 80.753","width":"25","height":"25"}},[_c('use',{attrs:{"xlink:href":"#icon--chat--neue"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }